import { storeToRefs } from 'pinia';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';
import { MarketPage } from '@/interface/enum';
import { useZone } from '@/libraries/composables/useZone';
import { getSportTypeKey } from '@/libraries/helpers/sportsHelper';
import { i18n } from '@/libraries/i18n';
import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
import { useRootStore } from '@/stores/rootStore';

const PRODUCT_KEY_MAP: Record<number, string> = {
    3: 'sportType_VirtualBasketball',
    6: 'sportType_VirtualFootball',
    9: 'eSportType_ESportsIm',
};

export function useSportsSwitch(
    isInOtherProduct: boolean,
): { sportsSwitchTitle: ComputedRef<string>, switchMpMode: () => void } {
    const { isInAnyZone, zoneTitleKey } = useZone();
    const { sportType, isMixParlayMode, marketPage } = storeToRefs(useRootStore());

    const otherProductDisplay = computed(() => {
        const { searchParams } = new URL(globalThis.location.href);

        if (searchParams.get('Provider') === 'ONEBX') {
            return `${i18n.t('sports')} › ${i18n.t('sportType_MuayThaiOneBx')}`;
        }

        const param = searchParams.get('product');
        const product = param ? Number.parseInt(param) : undefined;

        if (product && PRODUCT_KEY_MAP[product]) {
            return `${i18n.t('sports')} › ${i18n.t(PRODUCT_KEY_MAP[product])}`;
        }
        return i18n.t('sports');
    });

    const sportsSwitchTitle = computed(() => {
        if (isInOtherProduct) {
            return otherProductDisplay.value;
        }

        if (isInAnyZone.value && zoneTitleKey.value) {
            return `${i18n.t('sports')} › ${i18n.t(zoneTitleKey.value)}`;
        }

        const sportTypeKey = `sportType_${getSportTypeKey(sportType.value)}`;
        return `${i18n.t('sports')} › ${i18n.t(sportTypeKey)}`;
    });

    function switchMpMode() {
        const newIsMixParlayMode = !isMixParlayMode.value;
        useRootStore().handleSetIsMixParlayMode(newIsMixParlayMode);
        if (newIsMixParlayMode) {
            useHeaderDisplayStore().setState({
                isShowSportsFooter: true,
            });
        }

        if (isMixParlayMode.value && marketPage.value === MarketPage.Outright) {
            useRootStore().updateMarketPage();
        }
    }

    return {
        sportsSwitchTitle,
        switchMpMode,
    };
}
